import {useEffect, useRef} from "react";

import {RegistrationFlowStep} from "../../../auth/state/registration_flow_slice";
import {useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";

const AUTH_STEPS = [RegistrationFlowStep.REGISTRATION, RegistrationFlowStep.PHONE_COMPLETION, RegistrationFlowStep.PHONE_VERIFICATION];

/**
 * Hook that listens for when preferences flow completes for REGISTER_PROPERTY_PLAN.
 * When the flow closes after user saves preferences, it triggers the callback to show plan download modal,
 * or the plan delivered callback when the plan was already opened from the unlock choice modal during that flow.
 * A flow closed during the auth steps or by dismissing the unlock choice was abandoned, so neither callback fires.
 */
export const usePlanDownloadModal = (onFlowComplete: () => void, onPlanDelivered: () => void) => {
    const registrationFlowState = useAppSelector((state) => state.registrationFlow);
    const previousFlowActiveRef = useRef(false);
    const wasRegisterPropertyPlanRef = useRef(false);
    const wasPlanDeliveredRef = useRef(false);
    const wasAuthCompletedRef = useRef(false);

    useEffect(() => {
        const wasActive = previousFlowActiveRef.current;
        const isActive = registrationFlowState.isActive;
        const userSource = registrationFlowState.userSource;

        if (isActive && userSource === UserSource.REGISTER_PROPERTY_PLAN) {
            wasRegisterPropertyPlanRef.current = true;
            wasPlanDeliveredRef.current = registrationFlowState.unlockChoiceContentDelivered;

            if (!AUTH_STEPS.includes(registrationFlowState.currentStep)) {
                wasAuthCompletedRef.current = true;
            }
        }

        if (wasActive && !isActive && wasRegisterPropertyPlanRef.current) {
            if (wasAuthCompletedRef.current && !registrationFlowState.unlockChoiceDismissed) {
                if (wasPlanDeliveredRef.current) {
                    onPlanDelivered();
                } else {
                    onFlowComplete();
                }
            }

            wasRegisterPropertyPlanRef.current = false;
            wasPlanDeliveredRef.current = false;
            wasAuthCompletedRef.current = false;
        }

        previousFlowActiveRef.current = isActive;
    }, [
        registrationFlowState.isActive,
        registrationFlowState.userSource,
        registrationFlowState.unlockChoiceContentDelivered,
        registrationFlowState.currentStep,
        registrationFlowState.unlockChoiceDismissed,
        onFlowComplete,
        onPlanDelivered
    ]);
};
import {useEffect, useRef} from "react";

import {RegistrationFlowStep} from "../../../auth/state/registration_flow_slice";
import {useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";

const AUTH_STEPS = [RegistrationFlowStep.REGISTRATION, RegistrationFlowStep.PHONE_COMPLETION, RegistrationFlowStep.PHONE_VERIFICATION];

/**
 * Hook that listens for when preferences flow completes for REGISTER_PROPERTY_PLAN.
 * When the flow closes after user saves preferences, it triggers the callback to show plan download modal,
 * or the plan delivered callback when the plan was already opened from the unlock choice modal during that flow.
 * A flow closed during the auth steps or by dismissing the unlock choice was abandoned, so neither callback fires.
 */
export const usePlanDownloadModal = (onFlowComplete: () => void, onPlanDelivered: () => void) => {
    const registrationFlowState = useAppSelector((state) => state.registrationFlow);
    const previousFlowActiveRef = useRef(false);
    const wasRegisterPropertyPlanRef = useRef(false);
    const wasPlanDeliveredRef = useRef(false);
    const wasAuthCompletedRef = useRef(false);

    useEffect(() => {
        const wasActive = previousFlowActiveRef.current;
        const isActive = registrationFlowState.isActive;
        const userSource = registrationFlowState.userSource;

        if (isActive && userSource === UserSource.REGISTER_PROPERTY_PLAN) {
            wasRegisterPropertyPlanRef.current = true;
            wasPlanDeliveredRef.current = registrationFlowState.unlockChoiceContentDelivered;

            if (!AUTH_STEPS.includes(registrationFlowState.currentStep)) {
                wasAuthCompletedRef.current = true;
            }
        }

        if (wasActive && !isActive && wasRegisterPropertyPlanRef.current) {
            if (wasAuthCompletedRef.current && !registrationFlowState.unlockChoiceDismissed) {
                if (wasPlanDeliveredRef.current) {
                    onPlanDelivered();
                } else {
                    onFlowComplete();
                }
            }

            wasRegisterPropertyPlanRef.current = false;
            wasPlanDeliveredRef.current = false;
            wasAuthCompletedRef.current = false;
        }

        previousFlowActiveRef.current = isActive;
    }, [
        registrationFlowState.isActive,
        registrationFlowState.userSource,
        registrationFlowState.unlockChoiceContentDelivered,
        registrationFlowState.currentStep,
        registrationFlowState.unlockChoiceDismissed,
        onFlowComplete,
        onPlanDelivered
    ]);
};
